
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ColumnHeader } from '@/interfaces/components/ColumnHeader';
import headers from './headersCreatedJobTable';
import { CreatedItem } from '@/interfaces/models/SyncJobEntry';

@Component
export default class SyncCreatedTable extends Vue {
  @Prop({ type: Array, required: true }) public items!: CreatedItem[];
  @Prop({ type: Boolean, default: true }) public pagination!: boolean;
  @Prop({ type: String, default: true }) public title!: string;

  get tableHeaders() {
    return headers.map((h: ColumnHeader) => ({ ...h, text: this.$t(h.text) }));
  }
}
